import React from 'react'
import instagram from './instagram.svg'
import facebook from './facebook.svg'
import blog from './blog.svg'
import twitter from './twitter.svg'

const MenuItemWithIcon = (props: {
  content: string;
  href: string;
}) => {
  return (
    <a
      href={props.href}
    >
    <div
      style={{
        color: 'white',
        fontWeight: 700,
        padding: '10px',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'left',
          alignItems: 'center',
          gap: '10px',
        }}
      >
        {/* square icon */}
        <img src={
          props.content === '인스타그램' ? instagram :
          props.content === '블로그' ? blog :
          props.content === '페이스북' ? facebook : twitter
        } alt="instagram"
          style={{
            width: '30px',
            height: '30px',
          }}
        />
      {props.content}
      </div>
    </div>
    </a>
  )
}

export default MenuItemWithIcon